import { render, staticRenderFns } from "./editMultiLanguage.vue?vue&type=template&id=7a706c4a&"
import script from "./editMultiLanguage.vue?vue&type=script&lang=ts&"
export * from "./editMultiLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./editMultiLanguage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports